export enum Relation {
  PARTNER = "partner",
  GUARDIAN = "guardian",
  LEASING = "leasing",
  OTHER = "other",
}

export interface Owner {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly dateOfBirth?: string;
  readonly relation?: Relation;
  readonly socialSecurityNumber?: string;
  readonly isLeasingCompanyFromTFF: boolean;
}
